import axios from '../wmsAxios'

/*
 * 事务日志模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/exceptionLog/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/exceptionLog/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/exceptionLog/findPage',
        method: 'post',
        data
    })
}

// 根据ID查询
export const findById = (id) => {
    return axios({
        url: '/exceptionLog/findById?id=' + id,
        method: 'get'
    })
}

// 获取事务类型列表
export const getTranTypes = (data) => {
    return axios({
        url: '/exceptionLog/getTranTypes',
        method: 'post',
        data
    })
} 



// WEBPACK FOOTER //
// ./src/http/moudules/tExceptionLog.js